import React from "react";
import { Link } from "react-router-dom";
import style from "./PageNotFound.module.css";
import pageNotFound from "../../assets/images/page-not-found.png";
import history from "../../utils/history";

function PageNotFound() {
  const redirectLogin = () => {
    history.push("/");
  };
  return (
    <div id={style.pageNotFoundMainWrapper}>
      <div className="container">
        <div className="row mt-5">
          <div className="col-md-12">
            <img
              src={pageNotFound}
              className="img-fluid"
              alt="Page not found"
            />
            <h3>404- PAGE NOT FOUND</h3>
            <p>
              The page you are looking for might have been removed had its name
              changed or is temporarily unavailable
            </p>
            <div className={style.gotoRedirect}>
              <Link onClick={redirectLogin} className={style.goToHomePage}>
                GO TO HOMEPAGE
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageNotFound;
